<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    const loginToken = this.$route.params.id;

    if (loginToken !== "") {
      localStorage.token = loginToken;
    }

    this.$router.push({ name: "Login" });
  }
};
</script>